import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { FaCircleInfo } from "react-icons/fa6";
import "./CreateGroupModal.css";
import api from "../../api/apiClient";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useUserId } from "../../Utils/helpers";
import Select from "react-select";
import { clientUrlOptions } from "../../Utils/constants";

const NodeExportModal = ({ show, setShowExportModal, selectedNodes }) => {
  const [token, setToken] = useState("");
  const [secret, setSecret] = useState("");
  const [url, setUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const authToken = useSelector((state) => state.auth?.token);
  const userId = useUserId();
  const currentUrl = `${window.location.protocol}//${window.location.host}/`;

  const exportedInstances = selectedNodes.map(
    (selectedNode) => selectedNode.node.props.name
  );
  const exportedClasses = selectedNodes.map(
    (selectedNode) => selectedNode.node.class
  );

  const handleCloseExportModal = () => {
    setToken("");
    setSecret("");
    setUrl("");
    setShowExportModal(false);
  };

  const handleNodeExport = async () => {
    if (!token || !secret || !url) {
      toast.error("Please fill in all fields.");
      return;
    }

    const payload = {
      auth: authToken,
      exported_classes: exportedClasses,
      exported_instances: exportedInstances,
      not_exported_classes: [],
      not_exported_instances: [],
      secret,
      token,
      url,
      user_id: userId,
    };

    setLoading(true); // Start loading

    try {
      const checkResponse = await api.post("/credentials/check/", payload);

      if (checkResponse && checkResponse.data.success) {
        const response = await api.post("/export-data/", payload);

        if (response && response.data.success) {
          toast.success("Export successful!");
          handleCloseExportModal();
        } else {
          toast.error("Export failed!"); // Display error toast if export fails
        }
      } else {
        toast.error("Invalid credentials!"); // Add error message for failed check
      }
    } catch (error) {
      console.error("Error response:", error.response);
      const errorMessage =
        error.response?.data?.error ||
        "The data provided might be incorrect. Please try again.";
      toast.error(errorMessage);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleCloseExportModal}
      className="create-export-modal"
      style={{
        zIndex: 5000,
      }}
    >
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "18px" }}>Export</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <p>
            <FaCircleInfo style={{ marginRight: "8px" }} /> Enter Client Token
          </p>
          <Form.Control
            type="text"
            className="mb-3"
            value={token}
            onChange={(e) => setToken(e.target.value)}
          />
          <p>
            <FaCircleInfo style={{ marginRight: "8px" }} /> Enter Client Secret
          </p>
          <Form.Control
            type="text"
            className="mb-3"
            value={secret}
            onChange={(e) => setSecret(e.target.value)}
          />
          <p>
            <FaCircleInfo style={{ marginRight: "8px" }} /> Select Client URL
          </p>
          <Select
            value={
              clientUrlOptions.find((option) => option.value === url) || null
            }
            onChange={(selectedOption) => setUrl(selectedOption.value)}
            options={clientUrlOptions.filter(
              (option) => option.value !== currentUrl
            )}
            placeholder="Select a Client URL"
            className="mb-3"
          />
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          onClick={handleNodeExport}
          className="create-button"
          disabled={loading} // Disable the button if loading
        >
          {loading ? "Exporting..." : "Export"}
        </Button>
        <Button
          variant="secondary"
          onClick={handleCloseExportModal}
          className="cancell-button cancell-button-container"
        >
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default NodeExportModal;
